import { useScrollReveal } from '@/hooks/useScrollReveal';

const metrics = [
  {
    value: '2,400+',
    label: 'Tonnes of food waste prevented annually',
    icon: 'ri-shield-check-line',
  },
  {
    value: '18%',
    label: 'Average carbon reduction per delivery route',
    icon: 'ri-leaf-line',
  },
  {
    value: '47',
    label: 'Warehouse partners with green energy access',
    icon: 'ri-sun-line',
  },
  {
    value: '12M',
    label: 'Litres of water recycled by processing partners',
    icon: 'ri-water-flash-line',
  },
];

export default function ImpactMetrics() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="py-16 md:py-20 bg-secondary-50/30">
      <div ref={ref} className={`container-page scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="text-center mb-12 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Measurable Impact.
          </h2>
          <p className="text-foreground-500 max-w-xl mx-auto text-sm md:text-base leading-relaxed">
            Numbers that show what a connected, intelligent cold chain can do for India's food system and its environment.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {metrics.map((metric) => (
            <div key={metric.label} className="group bg-card-50 rounded-2xl border border-card-200 p-6 md:p-8 text-center shadow-sm hover:shadow-md hover:border-secondary-300/50 transition-all card-animate">
              <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center mx-auto mb-4 animate-icon-float icon-hover-pop">
                <i className={`${metric.icon} text-2xl text-secondary-600`}></i>
              </div>
              <div className="font-heading text-3xl md:text-4xl font-bold text-secondary-700 mb-2">
                {metric.value}
              </div>
              <div className="text-sm text-foreground-500 leading-relaxed">
                {metric.label}
              </div>
            </div>
          ))}
        </div>

        {/* Sustainability pledge banner */}
        <div className="mt-12 md:mt-16 bg-gradient-to-r from-brand-700 via-brand-600 to-brand-700 rounded-2xl p-8 md:p-10 text-center relative overflow-hidden shadow-sm">
          <div className="absolute inset-0 opacity-10"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            }}
          ></div>
          <div className="relative z-10">
            <div className="w-12 h-12 rounded-full bg-accent-400/20 flex items-center justify-center mx-auto mb-4">
              <i className="ri-earth-line text-2xl text-accent-400"></i>
            </div>
            <h3 className="font-heading text-xl md:text-2xl font-bold text-paper-50 mb-3">
              Our Pledge
            </h3>
            <p className="text-sm md:text-base text-brand-100/80 max-w-2xl mx-auto leading-relaxed">
              By 2030, Freshhlock aims to be a net-zero-emission logistics platform. Every new partner we onboard, every route we optimise, and every warehouse we connect brings us closer to that goal — not further away.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}